import { supabase } from '@/lib/supabase';

export const deleteDocument = async ({
  documentId,
  documentPath,
}: {
  documentId: number;
  documentPath: string;
}): Promise<number> => {
  const { error } = await supabase
    .from('project_documents')
    .delete()
    .eq('id', documentId);

  if (error) {
    throw error;
  }

  const { error: storageError } = await supabase.storage
    .from('documents')
    .remove([documentPath]);

  if (storageError) {
    throw storageError;
  }

  return documentId;
};
